import buildFieldByTemplate from "./template-fields";

function formatPhoneNumber(phoneNumberString) {
  const match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{4})$/);
  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phoneNumberString;
}

function extractZipCode(zip) {
  return zip.length === 9 ? zip.substr(0, 5) : zip;
}

export function buildPharmacyViewString(data) {
  return `${data.StoreName}\n${data["Address|AddressLine1"]} ${
    data["Address|AddressLine2"] || ""
  }\n${data["Address|City"]}, ${data["Address|State"]} ${extractZipCode(
    data["Address|ZipCode"]
  )}\n${formatPhoneNumber(data.PrimaryPhone)}`;
}

const getTemplateData = (screen, isMap) => {
  const templateFields = screen?.data?.templated_list?.fields;
  const mappingRules = screen?.data?.templated_list?.mapping;
  let template = null;
  let rules = null;

  if (templateFields && mappingRules) {
    if (isMap) {
      template = templateFields.map;
      rules = mappingRules.find(rulesSet => rulesSet.field === "map").rules;
    } else {
      template = templateFields.list;
      rules = mappingRules.find(rulesSet => rulesSet.field === "list").rules;
    }
  }

  return {
    template,
    rules
  };
};

export const buildPharmacies = (pharmacies, screen, isMap, mapKey) => {
  const { template, rules } = getTemplateData(screen, isMap);

  if (template && rules) {
    return (
      buildFieldByTemplate(template, rules, pharmacies, true, mapKey) || []
    );
  }
};

export const buildPharmacyStatusMessage = (screen, pharmacies, settings) => {
  const pharmacyStatusField = screen.fields.find(
    field => field.name === "pharmacy_status_message"
  );

  if (pharmacyStatusField) {
    pharmacyStatusField.title = pharmacyStatusField.title.replace(
      "%num_pharmacies%",
      pharmacies.all.length
    );

    if (pharmacies.all.length === 1) {
      pharmacyStatusField.title = pharmacyStatusField.title.replace(
        settings.translations.pharmacies.toLowerCase(),
        settings.translations.pharmacy.toLowerCase()
      );
    }
  }
};

export const searchButtons = [
  "selectedData",
  "currentLocation.mapSearchButton",
  "zipcode.mapSearchButton",
  "city.mapSearchButton",
  "citystate.mapSearchButton",
  "zipcodeMapSearchButton",
  "currentLocationMapSearchButton",
  "citystateMapSearchButton"
];

export const manualPharmacyFormState = {
  pharmacy_nm: "",
  "phone_faxes.0.phone_number": "",
  "phone_faxes.0.extension": "",
  "addresses.0.address_line1": "",
  "addresses.0.address_line2": "",
  "addresses.0.city": "",
  "addresses.0.state_province": "",
  "addresses.0.postal": "",
  twenty_four_hour_flg: "N"
};
